@if(showOtpVerification){
<kzn-otp-verification
  [userName]="userName"
  [requestId]="requestId"
  (navigateBackEvent)="cancelOTPVerification()"
></kzn-otp-verification>
} @else {
<div class="login">
  <img class="login__logo" src="assets/logo.png" alt="Kaizen" />
  <h2 class="login__title">Login to your account</h2>

  <form id="form-login" [formGroup]="loginForm" class="login__form" (ngSubmit)="onLogin()">
    <div class="login__field">
      <input
        type="text"
        class="login__input"
        placeholder="Email or Username"
        formControlName="userName"
        id="input-login-user-name"
      />
    </div>

    <div class="login__field">
      <input
        [type]="showPassword ? 'text' : 'password'"
        class="login__input"
        placeholder="Password"
        formControlName="password"
        id="input-login-password"
        autocomplete="current-password"
      />
      <button type="button" class="login__toggle-pw" (click)="togglePasswordVisibility()">
        <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </div>

    <div class="login__options">
      <label class="login__remember">
        <mat-checkbox color="primary" [(ngModel)]="rememberPassword" [ngModelOptions]="{standalone: true}">
          Remember Password
        </mat-checkbox>
      </label>
      <a class="login__forgot" routerLink="/reset-password">Forgot Password?</a>
    </div>

    <button
      type="submit"
      class="login__btn"
      [class.spinner]="isLoading"
      [disabled]="isLoading"
    >
      Login
    </button>
  </form>
</div>
}
